import React, { FC, HTMLAttributes } from 'react';

interface TableRowProps extends HTMLAttributes<HTMLTableRowElement> {
    data: string[];
    onClickRow?: () => void;
}

const TableRow: FC<TableRowProps> = ({ data, onClickRow = () => null }) => {
    return (
        <tr onClick={ onClickRow }>
            { data.map((item) => {
                return <td key={ item }>{ item }</td>
            }) }
        </tr>
    );
};

export default TableRow;